/* eslint-disable react/no-danger */
import type { AccordionTab } from '@presentation/components';
import { Accordion, Button } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import { TbCalendarEvent } from 'react-icons/tb';
import { PageSkeleton } from '../PageSkeleton';
import * as Styled from './styled';
import type { MtAnnouncementsProps } from './types';

export const MtAnnouncements: FC<MtAnnouncementsProps> = (props) => {
  const {
    announcementsLoading = false,
    announcements,
    onLoadMoreAnnouncementsClick,
    loadMoreAnnouncementsLoading,
    canLoadMoreAnnouncements,
  } = props;
  const { translate } = useTranslation();

  const tabs: AccordionTab[] = useMemo(() => {
    if (!announcements) {
      return [];
    }

    return announcements.map((item, index) => ({
      title: item.title,
      defaultChecked: index === 0,
      content: (
        <Styled.AccordionContent>
          <Styled.AccordionContentDate>
            <TbCalendarEvent /> {item.date}
          </Styled.AccordionContentDate>
          <p dangerouslySetInnerHTML={{ __html: String(item.content) }} />
        </Styled.AccordionContent>
      ),
    }));
  }, [announcements]);

  return (
    <>
      <Styled.Title>{translate('mt.breeder.news.title')}</Styled.Title>

      {announcementsLoading ? <PageSkeleton /> : <Accordion tabs={tabs} noScroll />}
      {onLoadMoreAnnouncementsClick && canLoadMoreAnnouncements && (
        <Styled.LoadMoreContainer>
          <Button
            color="blue"
            shrink
            outlined
            onClick={onLoadMoreAnnouncementsClick}
            loading={loadMoreAnnouncementsLoading}
          >
            {translate('common.buttons.seeMore')}
          </Button>
        </Styled.LoadMoreContainer>
      )}
    </>
  );
};
